import React from "react";
import { styled } from "@glitz/react";

export const enum ContentWidth {
  Wide = 1600,
  Normal = 1440,
  Narrow = 990,
  ExtraNarrow = 660,
}

type ContentWidthProps = {
  contentWidth?: ContentWidth;
  children?: React.ReactNode;
};

const ContentWidthDiv = styled.div({ maxWidth: "100%", margin: { x: "auto" } });

const Base: React.FC<ContentWidthProps> = ({
  contentWidth = ContentWidth.Normal,
  children,
}) => {
  const dynamicStyles = React.useMemo(() => {
    const styles = {
      width: `${contentWidth}px`,
    };

    return styles;
  }, [contentWidth]);

  return <ContentWidthDiv css={dynamicStyles}>{children}</ContentWidthDiv>;
};

export default Base;
